/* eslint-disable @typescript-eslint/naming-convention */
import axiosInstanceApiKong from 'config/apiServiceApiGateway'

export type MasterAreaPickingQueryType = {
  page_size: string
  page_index?: number
  location_id?: number
  search_name?: string
}

export type MasterAreaPickingDataType = {
  id: number
  name: string
  location_id: number
  location_name: string
}

export type MasterAreaPickingPaginationType = {
  page_index: number
  page_size: string
  total_elements: number
}

export type GetMasterAreaPickingListResponseType = {
  data: MasterAreaPickingDataType[]
  pagination: MasterAreaPickingPaginationType
}
export type UpsertMasterAreaPickingPayloadType = {
  name: string
  location_id: number
}

export const fetchMasterAreaPickingListAPI = (params: MasterAreaPickingQueryType) =>
  axiosInstanceApiKong.Get<GetMasterAreaPickingListResponseType, true>({
    url: '/wims/internal/:version/picking-areas',
    version: 'v1',
    params: {
      ...params,
      'pagination.page_size': params.page_size || '20',
      'pagination.page_index': params.page_index || 1,
    },
  })

export const fetchMasterAreaPickingDetailAPI = (id: number) =>
  axiosInstanceApiKong.Get<{ data: MasterAreaPickingDataType }, true>({
    url: '/wims/internal/:version/picking-areas/:id',
    version: 'v1',
    urlParams: { id },
  })

export const createMasterAreaPickingAPI = (data: UpsertMasterAreaPickingPayloadType) =>
  axiosInstanceApiKong.Post({
    url: '/wims/internal/:version/picking-areas',
    version: 'v1',
    data,
  })

export const updateMasterAreaPickingAPI = (id: number, data: UpsertMasterAreaPickingPayloadType) =>
  axiosInstanceApiKong.Put({
    url: '/wims/internal/:version/picking-areas/:id',
    version: 'v1',
    data,
    urlParams: { id },
  })
